// ------ SKELETONS' COLORS ------
export const baseColorSkeletonDark = 'var(--color-backgroundSecondary)'
export const highlightColorSkeletonDark = 'var(--color-backgroundTertiary)'

export const baseColorSkeletonLight = 'var(--color-backgroundPrimary)'
export const highlightColorSkeletonLight = 'var(--color-backgroundSecondary)'

export enum ALGOLIA_INDEXES {
  PUBLIC_COLLECTIONS_AND_ARTCILES = 'public_collections_and_articles_index',
  ALL_COLLECTIONS_AND_ONLY_PUBLIC_ARTCILES = 'all_collections_and_only_public_articles_index'
}
